import { render, staticRenderFns } from "./ProjectModel.vue?vue&type=template&id=351b4a41&scoped=true&"
import script from "./ProjectModel.vue?vue&type=script&lang=js&"
export * from "./ProjectModel.vue?vue&type=script&lang=js&"
import style0 from "./ProjectModel.vue?vue&type=style&index=0&id=351b4a41&prod&lang=css&"
import style1 from "./ProjectModel.vue?vue&type=style&index=1&id=351b4a41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351b4a41",
  null
  
)

export default component.exports